import { Button, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loading from "@/components/Loading";
import type {
  CaseResponse,
  JurisdictionResponse,
  UserResponse,
} from "@/lib/types";
import { leadAttorneyName } from "@/screens/CaseManagementMulti/case";
import { getCaseSourceLogo } from "@/utils/ExternalPartner/utils";

interface Props {
  addCase: () => void;
  cases: CaseResponse[] | undefined;
  jurisdictions: JurisdictionResponse[] | undefined;
  users: UserResponse[] | null;
  showIfEmpty: boolean;
}

export default function CaseTableMulti({
  addCase,
  cases,
  jurisdictions,
  users,
  showIfEmpty,
}: Props) {
  function venueDisplay(_case: CaseResponse) {
    const j = jurisdictions?.find((x) => x.id === _case.jurisdiction);
    return j?.venues?.find((x) => x.id === _case.venue)?.shortName ?? "-";
  }

  return (
    <Loading
      isLoading={
        cases === undefined &&
        jurisdictions === undefined &&
        users === undefined
      }
    >
      {(showIfEmpty || (cases?.length !== undefined && cases?.length > 0)) && (
        <div>
          {cases?.length ? (
            <Row>
              <Table striped hover style={{ marginLeft: "12px" }}>
                <thead>
                  <tr className="table-header">
                    <th className="table-header-cell" scope="">
                      Title
                    </th>
                    <th className="table-header-cell" scope="">
                      Case Number
                    </th>
                    <th className="table-header-cell" scope="">
                      Venue
                    </th>
                    <th className="table-header-cell" scope="">
                      Lead Attorney
                    </th>
                    <th className="table-header-cell" scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {cases?.map((c) => {
                    return (
                      <tr className="table-row" key={c.id}>
                        <td className="table-cell">
                          <span
                            style={{ width: "18px", display: "inline-block" }}
                          >
                            {getCaseSourceLogo(c.integration?.partner)}
                          </span>{" "}
                          {c.shortTitle || c.title}
                        </td>
                        <td className="table-cell">{c.caseNumber ?? "-"}</td>
                        <td className="table-cell">{venueDisplay(c)}</td>
                        <td className="table-cell">
                          {leadAttorneyName(c, users ?? [])}
                        </td>
                        <td className="actions-cell">
                          <Link
                            data-testid="view-case-button"
                            className="btn btn-outline-primary btn-26"
                            to={{
                              pathname: `/cases/${c.id}`,
                              state: {
                                case: c,
                              },
                            }}
                          >
                            View Case
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Row>
          ) : (
            <div className="d-flex gap-1 align-items-center">
              There are no Cases yet:
              <Button variant="link" onClick={addCase} className="p-0">
                Add one now
              </Button>
              or just start by uploading a document.
            </div>
          )}
        </div>
      )}
    </Loading>
  );
}
